import $ from "jquery";

const onClickSectionTabHome = () => {
  const init = () => {
    $(document).ready(function () {
      exec();
    });
  };
  const exec = () => {
    $(".section-tab__nieuw").on("click", function () {
      $("#section-content__nieuw").fadeIn(500);
      $("#section-content__sale").attr("style", "display:none;");
      
      $(this).toggleClass("active");
      $(".section-tab__sale").removeClass("active");
    });
    $(".section-tab__sale").on("click", function () {
      $("#section-content__nieuw").attr("style", "display:none;");
      $("#section-content__sale").fadeIn(500);
      
      $(this).toggleClass("active");
      $(".section-tab__nieuw").removeClass("active");
    });
  };
  init();
};

try {
  onClickSectionTabHome();
} catch (err) {
  console.error(err);
}
